
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import { Rating } from 'primereact/rating';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { ProductService } from '../service/ProductService';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Link } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";
import { SERVER_HOST } from '../settings';

export default function BiggestRatingChanges({gameMode = 'overall'}) {
    const [biggestClimbs, setBiggestClimbs] = useState([]);
    const [biggestFalls, setBiggestFalls] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        // console.log("API call triggered with gameMode:", gameMode);

        fetch(`${SERVER_HOST}/biggestratingchanges/${gameMode}`).then(data=>data.json()).then(data => {
            setBiggestClimbs(data.climbs);
            setBiggestFalls(data.falls);
        });
    }, [gameMode]);

    useEffect(() => {
        const params = {};
        if (gameMode) {
            params.gameMode = gameMode;
        }
        setSearchParams(params);
      }, [gameMode]);

    const itemTemplate = (player, index) => {
        const isUp = player.ratingChange > 0;
        return (
            <div className="col-12" key={player.userInternalId}>
                <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': index !== 0 })}>
                    <img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" src={`https://www.geoguessr.com/images/resize:auto:420:420/gravity:ce/plain/pin/${player.fullBodyPath}.png`} alt={player.nick} />
                    <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                        <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                            <div className="text-2xl font-bold text-900">
                                <Link to={`/player/${player.userId}`}>
                                    {player.nick}
                                    &nbsp;
                                    <img src={`/flags/${player.countryCode}.png`} style={{ width: '24px' }} />
                                </Link>
                            </div>
                            <table cellSpacing={12}>
                                <tbody>
                                    <tr>
                                        <td className='align-items-center' style={{'paddingLeft': '1rem'}}>
                                            <Tag value={'Rating'} severity={isUp ? 'success' : 'danger'}></Tag>
                                        </td>
                                        <td className='flex align-items-center gap-2' style={{'paddingTop': '4px'}}>
                                            <span className="flex align-items-center gap-2">
                                                <i className="pi pi-chart-line"></i>
                                                <span className="font-semibold">{player.oldRating}</span>
                                            </span>
                                            <span className="flex align-items-center gap-2">
                                                <i className="pi pi-angle-double-right"></i>
                                                <span className="font-semibold">{player.currentRating}</span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='align-items-center' style={{'paddingLeft': '1rem'}}>
                                            <Tag value={'Position'} severity={isUp ? 'success' : 'danger'}></Tag>
                                        </td>
                                        <td className='flex align-items-center gap-2' style={{'paddingTop': '4px'}}>
                                            <span className="flex align-items-center gap-2">
                                                <i className="pi pi-list"></i>
                                                <span className="font-semibold"># {player.oldPosition}</span>
                                            </span>
                                            <span className="flex align-items-center gap-2">
                                                <i className="pi pi-angle-double-right"></i>
                                                <span className="font-semibold"># {player.currentPosition}</span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                            <span className={`font-semibold flex gap-2 text-${player.ratingChange > 0 ? 'teal' : 'red'}-300`}><i className={`pi pi-sort-${player.ratingChange > 0 ? 'up' : 'down'}`}></i>{player.ratingChange}</span>
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((product, index) => {
            return itemTemplate(product, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    return (
        <div className="grid">
            <div className="md:col-offset-1 md:col-5 col-12">
                <Card className="card" title='Biggest climbs of the week'>
                    <DataView value={biggestClimbs} listTemplate={listTemplate} />
                </Card>
            </div>
            <div className="md:col-offset-0 md:col-5 col-12">
                <Card className="card" title='Bigest falls of the week'>
                    <DataView value={biggestFalls} listTemplate={listTemplate} />
                </Card>
            </div>
        </div>
    )
}